import React, { useContext } from "react"
import { Context as AdminContext } from "@components/ui-builder/admin-context"

export const filterItems = (items, taxonomy) => {
  if (taxonomy) {
    const isPersonal = taxonomy[0] === "*"
    if (isPersonal) {
      taxonomy = taxonomy.substring(1)
    }

    // filter by taxonomy and override sort
    return items.reduce((list, i) => {
      const tax =
        i.taxonomies && i.taxonomies.find(t => t.taxonomy === taxonomy)
      if (tax) {
        list.push({
          ...i,
          // override sort value
          sort: tax.sort,
          // filter all trivias by taxonomy and user-specificity
          trivias: i.trivias
            ? i.trivias.filter(
                t =>
                  t.taxonomies.includes(taxonomy) &&
                  (t.user_specific == 0 || t.user_specific > 0 === isPersonal)
              )
            : [],
        })
      }
      return list
    }, [])
  } else {
    // No trivias without filter
    return items.map(i => ({
      ...i,
      trivias: [],
    }))
  }
}

export const Filter = ({ options, selected, onSelect }) => {
  return (
    <div className={"form-group"}>
      <select
        className="form-control"
        value={selected}
        onChange={e => onSelect(e.target.value)}
      >
        {options.map(([val, label]) => (
          <option key={val} value={val}>
            {label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default props => {
  const isAdmin = useContext(AdminContext)
  const numOptions = props.options?.filter(o => !o[0].startsWith("*")).length
  return numOptions > 1 && !isAdmin ? <Filter {...props} /> : null
}
